module.exports = __webpack_public_path__ + "static/media/studiofoto-roadbike_V-500.2dbc6074.jpg";